import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Type")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Value")
], -1)
const _hoisted_4 = {
  key: 1,
  style: {"padding":"20px","text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.containerRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_row, { gutter: 10 }, {
            default: _withCtx(() => [
              (
					_ctx.containerRef.action.type || _ctx.containerRef.action.type == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      _createVNode(_component_a_select, {
                        style: {"width":"100%"},
                        defaultValue: "normal",
                        value: _ctx.containerRef.action.type,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.containerRef.action.type) = $event)),
                        onChange: _ctx.actionChanged
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode("None")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "go-to-page" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Go to page ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "go-to-url" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Go to URL ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "drop-items" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Drop items ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "claim-item" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Claim item ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "redeem-item" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Redeem item ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "redeem-url-item" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Redeem URL item ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "redeem-momint-nft" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Redeem momint nft ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "open-popup" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Open popup ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "close-popup" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Close popup ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "center-map" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Center map ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "signup" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Sign up")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "signin-request-code" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Sign in request code")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "submit-pin" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Submit pin ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "show-scanner" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Show QR code scanner ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "share-link" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Share campaign link ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "log-out" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Logout ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_select_option, { value: "resend-pin" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Resend pin ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value", "onChange"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
					_ctx.containerRef.action.value || _ctx.containerRef.action.value == ''
				)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 1,
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      (_ctx.containerRef.action.type != 'share-link')
                        ? (_openBlock(), _createBlock(_component_a_input, {
                            key: 0,
                            value: _ctx.containerRef.action.value,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.containerRef.action.value) = $event)),
                            placeholder: "Value",
                            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePage()))
                          }, null, 8, ["value"]))
                        : (_openBlock(), _createBlock(_component_a_select, {
                            key: 1,
                            style: {"width":"100%"},
                            defaultValue: "normal",
                            value: _ctx.containerRef.action.value,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.containerRef.action.value) = $event)),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectPoolID()))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dropPoolsRef, (pool) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: pool.id,
                                  key: pool.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(pool.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"]))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.containerRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Please select an element or container "))
      : _createCommentVNode("", true)
  ], 64))
}